import React, { createContext } from 'react';

export type TriggerEvent = 'click' | 'context';

interface ContextMenuContext {
	lastEventRef: React.MutableRefObject<React.MouseEvent | null>;
	toggleDropdown(e: React.MouseEvent): void;
	trigger?: TriggerEvent;
}

// Create a safe context implementation
function createSafeContext<T>(errorMessage: string) {
	const Context = createContext<T | undefined>(undefined);

	const useContext = () => {
		const context = React.useContext(Context);
		if (context === undefined) {
			throw new Error(errorMessage);
		}
		return context;
	};

	return [Context.Provider, useContext] as const;
}

export const [ContextMenuProvider, useContextMenuContext] =
	createSafeContext<ContextMenuContext>('ContextMenuContext is undefined');
